import { render } from "./VitrinePro.vue?vue&type=template&id=70fde453&scoped=true"
import script from "./VitrinePro.vue?vue&type=script&lang=js"
export * from "./VitrinePro.vue?vue&type=script&lang=js"

import "./VitrinePro.vue?vue&type=style&index=0&id=70fde453&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fde453"]])

export default __exports__